import { meetingIsOver } from './meetingIsOver.ts';
import type { MeetingPageResponse } from '@wundo/shared/meetingPage.ts';

/**
 * The verslag tab when nothing is on its way to it (`report_pending`): the
 * notetaker still to sit in, the user's own notes as the way in, or a verslag.
 */
export type MeetingReportState = 'scheduled' | 'paste' | 'document';

export function meetingReportState(
  page: MeetingPageResponse,
  now: Date,
): MeetingReportState {
  if (page.report) return 'document';
  return page.decision.record && !meetingIsOver(page, now) ? 'scheduled' : 'paste';
}
